import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import MemberDirectoryPage from "@/pages/member/MemberDirectoryPage";

export const Route = createFileRoute("/member/directory")({
  head: () => pageHead("Member · Directory", "AKIVA member · directory portal.", "/member/directory", true),
  component: MemberDirectoryPage,
});
